import { GitBranch } from 'lucide-react';
import { SECTION_COLOR } from './receptUtils';

const pill = (bg, color) => ({
    display: 'inline-flex', alignItems: 'center', gap: 3,
    padding: '1px 6px', borderRadius: 999, fontSize: 9, fontWeight: 700,
    background: bg, color, whiteSpace: 'nowrap', flexShrink: 0,
});

// Sdílené stavové odznaky pro seznam i hero.
// Zastaralost revize řeší třístupňový výkřičník (RecipeValidaceBadge), zde už ne.
// pouzitoCount === 0 ⇒ osiřelý polotovar (varování). undefined ⇒ neznámé (neřešíme).
export default function RecipeStatusBadges({ aktivni, varCount = 0, pouzitoCount, showVariants = true }) {
    const orphan = pouzitoCount === 0;

    return (
        <>
            {showVariants && varCount > 1 && (
                <span style={pill('rgba(245,158,11,0.15)', SECTION_COLOR)}><GitBranch size={9} />{varCount}</span>
            )}
            {orphan && (
                <span style={pill('rgba(245,158,11,0.15)', SECTION_COLOR)} title="Nepoužívá se v žádném receptu">0×</span>
            )}
            {aktivni === false && (
                <span style={pill('rgba(239,68,68,0.15)', '#EF4444')}>Off</span>
            )}
        </>
    );
}
